/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const DetailsTitle = styled.div`
  min-width: 10rem;
  word-break: break-all;
  color: ${theme.color.text.text02};
  text-transform: ${theme.typography.titleCase};
`;
